module.exports = __webpack_public_path__ + "static/media/teamexile.137199ad.svg";